module.exports = __webpack_public_path__ + "html/location-form.template.html";